import { FunnelImage, ScreenBackground } from '../Content';
import { BaseScreenAttributes } from './BaseScreenAttributes';
import { ScreenType } from './ScreenType';

export enum SectionInformationalDynamicType {
  TITLE = 'TITLE',
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  SPACE = 'SPACE',
}

type SectionText = {
  type: SectionInformationalDynamicType.TEXT | SectionInformationalDynamicType.TITLE;
  value: string;
};

type SectionImage = {
  type: SectionInformationalDynamicType.IMAGE;
  value: FunnelImage;
};

type SectionSpace = {
  type: SectionInformationalDynamicType.SPACE;
  value: VariantSpaceInformationalDynamic;
};

export type SectionInformationalDynamic = SectionText | SectionImage | SectionSpace;
export type VariantInformationalDynamic = 'primary' | 'secondary';
export type VariantSpaceInformationalDynamic = 'small' | 'medium' | 'large';

export interface InformationalDynamicScreenAttributes extends BaseScreenAttributes {
  dataKey: string;
  variant?: VariantInformationalDynamic;
  content: {
    sections: Array<SectionInformationalDynamic>;
    backgroundImage?: ScreenBackground;
    button: string;
  };
  screenType: ScreenType.INFORMATIONAL_DYNAMIC;
}
